import type { SVGProps } from "react";

export function IconWhiteThreeArrows(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M57 7L7 57M57 7H37M57 7V27M57 37L37 57M57 37H37M57 37V57M27 7L7 27M27 7H7M27 7V27"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
